/**
 * Import Dependency
 */

/**
 * Import API
 */
import { getConfig } from 'service/faunadb.js'

/**
 * Declare Variable
 */
const state = {
  id: '',
  ref: '',
  name : '',
  years: [2020, 2025, 2030],
  planmode: false,
  center: [],
  zoom: 12.94,
  layers: {},
  loaded: false
}

const getters = {
  id: state => state.id,
  ref: state => state.ref,
  name: state => state.name,
  years: state => state.years,
  center: state => state.center,
  zoom: state => state.zoom,
  layers: state => state.layers,
  planmode: state => !!state.planmode,
  loaded: state => state.loaded
}
const actions = {
  async getConfig({ commit }, { ref }) {
    let response = await getConfig({ ref })
    if (response) {
      commit('setConfig', response)
    }
  }
}
const mutations = {
  setConfig(state, data) {
    Object.keys(state).forEach(key => {
      if (data[key]) {
        state[key] = data[key]
      }
    })
    state.loaded = true
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
